import { resolveTypographyVariantStyles } from '@aspendental/themes';
import { Theme } from '@mui/material';

import { toolbarHeaderStyles } from '../Header/HeaderMobile/HeaderMobile.styles';

const mobileHeaderHeight = toolbarHeaderStyles.height;

export const getTitleContainerStyles = (hasDescription: boolean) => ({
	alignItems: 'center',
	justifyContent: 'center',
	paddingX: { xs: '1.25rem', md: '2%', lg: '5%', xl: '6rem' },
	textAlign: 'center',
	textWrap: 'pretty',
	maxWidth: { xs: '100%', sm: '100%', md: hasDescription ? '50%' : '100%' },
	margin: `0 auto`,
});

export const titleStyles = {
	paddingTop: '2.5rem',
};

export const chipStyles = {
	color: 'secondary.main',
	borderColor: 'secondary.main',
	'&:hover': {
		color: 'secondary.main',
		backgroundColor: 'neutrals.white',
		opacity: 0.8,
	},
	'&.Mui-selected': {
		backgroundColor: 'secondary.main',
		color: 'neutrals.white',
		'&:hover': {
			color: 'neutrals.white',
			backgroundColor: 'secondary.main',
			opacity: 0.8,
		},
	},
};

export const filterListStyles = {
	display: 'flex',
	flexWrap: 'wrap',
	justifyContent: 'center',
	gap: '1rem',
	padding: '2rem 0',
};

export const tagDropdownWrapperStyles = {
	width: '100%',
	maxWidth: { xs: '100%', sm: '24rem' },
	margin: '1rem auto 0',
};

export const tagDropdownStyles = {
	textAlign: 'left',
	backgroundColor: 'backgrounds.white',
	'.MuiSelect-select': {
		paddingY: '.875rem',
	},
};

export const topicsWrapperStyles = {
	paddingX: { xs: '1.25rem', md: '2%', lg: '5%', xl: '6rem' },
};

export const topicsHeaderStyles = {
	display: 'flex',
	alignItems: 'center',
	flexFlow: 'row wrap',
	justifyContent: 'left',
	gap: '.5rem',
	paddingY: '0.75rem',
};

export const topicsListStyles = {
	borderTop: '1px solid',
	borderColor: 'neutrals.primary',
	display: 'flex',
	flexWrap: 'wrap',
	gap: '.75rem',
	paddingY: '0.75rem',
};

export const topicsIconStyles = {
	flexShrink: 0,
};

export const topicsDrawerSelectedListStyles = {
	display: 'flex',
	flexWrap: 'wrap',
	gap: '.75rem',
	flexShrink: 0,
};

export const topicsFiltersButtonStyles = {
	display: 'flex',
	alignItems: 'center',
	gap: '.5rem',
	background: 'none',
	border: 'none',
	cursor: 'pointer',
	padding: 0,
};

export const topicsDrawerPaperStyles = {
	width: { xs: '100%', sm: '42rem' },
	maxWidth: { xs: '100%', sm: 'calc(100% - 1rem)' },
	height: { xs: `calc(100% - ${mobileHeaderHeight})`, sm: '100%' },
	maxHeight: { xs: `calc(100vh - ${mobileHeaderHeight})`, sm: '100vh' },
	margin: 0,
	marginTop: { xs: mobileHeaderHeight, sm: 0 },
	marginLeft: { xs: 0, sm: '1rem' },
	display: 'flex',
	flexDirection: 'column',
	borderRadius: { xs: '8px 8px 0 0', sm: '8px 0 0 8px' },
};

export const topicsDrawerBackdropStyles = {
	backgroundColor: 'rgba(0, 0, 0, 0.8)',
};

const commonContainerStyles = {
	padding: '1.25rem',
};

export const topicsDrawerHeaderStyles = {
	display: 'flex',
	flexDirection: 'column',
	gap: '1.5rem',
	...commonContainerStyles,
};

export const topicsDrawerTitleStyles = {
	display: 'flex',
	flexFlow: 'row nowrap',
	alignItems: 'center',
	justifyContent: 'space-between',
	borderBottom: '1px solid',
	borderColor: 'neutrals.primary',
	flexShrink: 0,
	paddingBottom: '.75rem',
};

export const topicsDrawerCloseButtonStyles = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	color: 'text.secondary',
};

export const topicsDrawerListStyles = {
	flex: '1 1 auto',
	overflowY: 'auto',
	...commonContainerStyles,
	paddingTop: 0,
};

const spacingCalculator = (value: number) => 0.5 * value;

export const topicsDrawerGroupHeaderStyles = {
	paddingY: `${spacingCalculator(1)}rem`,
	marginBottom: `${spacingCalculator(0.75)}rem`,
	borderBottom: '1px solid',
	borderColor: 'neutrals.primary',
};

export const topicsDrawerRowStyles = {
	display: 'flex',
	flexFlow: 'row nowrap',
	alignItems: 'center',
	paddingY: `${spacingCalculator(0.75)}rem`,
	cursor: 'pointer',
};

export const topicsDrawerCheckboxStyles = {
	padding: 0,
	marginRight: '0.5rem',
	'&.Mui-checked': {
		color: 'secondary.main',
	},
};

export const topicsDrawerActionsStyles = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	gap: '1rem',
	borderTop: '1px solid',
	borderColor: 'neutrals.primary',
	flexShrink: 0,
	...commonContainerStyles,
};

export const topicsDrawerClearButtonStyles = {
	backgroundColor: 'common.white',
	border: 'none',
};

export const topicsPillStyles = (theme: Theme) => ({
	...resolveTypographyVariantStyles(theme, 'chipLabel'),
	color: 'secondary.main',
	minHeight: 'auto',
	padding: '0.5rem 0.625rem',
	'& .MuiButton-endIcon': {
		marginLeft: '0.25rem',
		marginRight: '-0.125rem',
		color: 'inherit',
		'& > *:nth-of-type(1)': {
			fontSize: '0.875rem',
		},
	},
});
